module.exports = __webpack_public_path__ + "static/media/background-main.a0815d3a.jpg";